import React from "react";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import { useModalContext } from "../../contexts/ModalContext/context";

interface IProps {
  title?: string;
  fullWidth?: boolean;
  onClose?: VoidFunction;
  actions?: React.ReactNode;
  maxWidth?: DialogProps["maxWidth"];
}

export const ModalWithoutOverflow: React.FC<IProps> = (props) => {
  const { isOpen, setIsOpen } = useModalContext();

  function handleClose() {
    if (props.onClose) {
      props.onClose();
    }

    setIsOpen(false);
  }

  return (
    <Dialog
      fullWidth={props.fullWidth}
      open={isOpen}
      onClose={handleClose}
      maxWidth={props.maxWidth}
      PaperProps={{
        sx: { overflow: "visible" },
      }}
    >
      {props.title && <DialogTitle>{props.title}</DialogTitle>}
      <DialogContent sx={{ p: 0, borderTop: (props) => `1px solid ${props.palette.divider}`, overflow: "visible" }}>
        {props.children}
      </DialogContent>
      {props.actions && <DialogActions sx={{ px: 3, pb: 2 }}>{props.actions}</DialogActions>}
    </Dialog>
  );
};

ModalWithoutOverflow.defaultProps = {
  maxWidth: "sm",
};
